import {
    Autocomplete,
    TextField,
    FormControl as MuiFormControl,
} from "@mui/material";
import { Property } from "types";

export const addTag = "__tags_add__";
export const removeTag = "__tags_remove__";

export type MultiEditTagFormControlProps = {
    value?: string,
    property: Property,
    tagOptions?: string[],
    onChange?: (newValue: string) => void,
};

export function MultiEditTagFormControl({
    value = "",
    property,
    tagOptions = [],
    onChange,
}: MultiEditTagFormControlProps) {
    const isRemove = property.name === removeTag
    const label = isRemove ? "Remove Tag" : "Add Tag"

    return (
        <MuiFormControl fullWidth size="small">
            <Autocomplete
                size="small"
                fullWidth
                freeSolo={!isRemove}
                disableClearable
                data-testid={`field-${property.name}`}
                options={tagOptions}
                value={value.replace("(create new)", "")}
                filterOptions={(options, params) => {
                    const filtered = options.filter(option =>
                        option.toLowerCase().includes(params.inputValue.toLowerCase())
                    );
                    if (
                        !isRemove &&
                        params.inputValue &&
                        !options.includes(params.inputValue)
                    ) {
                        filtered.push(`${params.inputValue} (create new)`);
                    }
                    return filtered;
                }}
                onChange={(_, newValue) => {
                    if (typeof newValue === "string") {
                        onChange?.(newValue.replace("(create new)", ""));
                    }
                }}
                onInputChange={(_, newInputValue) => {
                    onChange?.(newInputValue.replace("(create new)", ""));
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        inputProps={{
                            ...params.inputProps,
                            "data-testid": `input-${property.name}`,
                        }}
                    />
                )}
            />
        </MuiFormControl>
    );
}